/* eslint-disable no-console */
import store from 'store';
import jwtDecode from 'jwt-decode';
import { axiosClient } from '../../api';

import { hasAdminAccess } from '../../utils';

window.store = store;

// utils
const isNewToken = (prevToken, newToken) => {
  return prevToken !== newToken;
};

const state = {
  pid: store.get('pid'), // portal token
  user: null,
  impid: store.get('impid'), // impersonated user token
  impersonatedUser: null,
};

const getters = {
  user: state => () => state.user,
};

const actions = {
  async impersonate({ commit }, id) {
    const { data } = await axiosClient.post(`/admin/customers/${id}/impersonate`);
    const token = data.access_token;
    commit('impersonate', token);
    return token;
  },

  // Since employees ( admins ) can impersonate customers, they can also make changes to the customer settings.
  // When the admin ( impersonator ) is the one making the changes we update the impersonator's info
  // When the customer is the one making their changes, we update the user's info
  async updateCustomerAccount({ commit, state }, customerData) {
    try {
      const impersonatedUser = state.impersonatedUser;
      const user = state.user;

      const { data } = await axiosClient.put('customer', customerData);

      if (impersonatedUser && user && hasAdminAccess(user)) commit('impersonate', data.token);
      else commit('login', data.token);
    } catch (error) {
      console.error({ ...error });
    }
  },

  async updateAdminAccount({ commit }, data) {
    try {
      const res = await axiosClient.put('/admin/update', data);
      commit('login', res.data.token);
      return res;
    } catch (error) {
      console.error({ ...error });
    }
  },

  async unlockTrainings({ commit }) {
    try {
      const res = await axiosClient.put('customer', { unlocked_trainings: 1 });
      commit('unlockTrainings', res.data.token);
    } catch (error) {
      console.error({ ...error });
    }
  },
};

const mutations = {
  login(state, token) {
    isNewToken(state.pid, token) && store.set('pid', token);
    const { user, customer } = jwtDecode(token);
    state.user = { ...customer, ...user };
    state.pid = token;
  },

  impersonate(state, token) {
    isNewToken(state.impid, token) && store.set('impid', token);
    const { user, customer } = jwtDecode(token);
    state.impersonatedUser = { ...customer, ...user }; // override customer's props with user
    state.impid = token;
  },

  logout(state) {
    state.pid = null;
    state.user = null;
    state.imp = null;
    state.impersonatedUser = null;
    store.clearAll();
  },

  unlockTrainings(state, token) {
    mutations.login(state, token);
  },
};

// login user | admin | impersonated user if token found in the store
if (state.pid) mutations.login(state, state.pid);
if (state.impid) mutations.impersonate(state, state.impid);

export const auth = {
  actions,
  getters,
  state,
  mutations,
  namespaced: true,
};
